import { render, staticRenderFns } from "./NewsPageNutraingredients.vue?vue&type=template&id=20d228fe&scoped=true&"
import script from "./NewsPageNutraingredients.vue?vue&type=script&lang=js&"
export * from "./NewsPageNutraingredients.vue?vue&type=script&lang=js&"
import style0 from "./NewsPageNutraingredients.vue?vue&type=style&index=0&id=20d228fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d228fe",
  null
  
)

export default component.exports